const elemA = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 316 274'
		fill='none'
	>
		<path
			d='M115.485 1.93418C115.057 3.02386 89.0125 64.0932 57.5779 137.755C26.1433 211.417 0.27371 272.164 0.0110254 272.742C-0.329492 273.491 7.12296 273.747 35.561 273.747H71.5586L74.6427 265.986C76.2674 261.817 81.0639 249.471 85.2668 238.707L92.8944 219.102L157.914 218.931L222.933 218.685L233.557 246.221L244.181 273.756H280.072C299.773 273.756 315.875 273.51 315.875 273.093C315.875 272.676 289.665 211.275 257.792 136.523L199.71 0.531723L157.992 0.285352L116.254 0.0959473L115.485 1.93418ZM162 60.3313C165.425 72.2608 171.165 87.81 189.844 135.187C196.956 153.295 202.697 168.228 202.492 168.351C202.288 168.474 182.061 168.522 157.515 168.437L112.888 168.19L126.255 134.401C148.438 78.0884 152.3 67.4096 156.153 52.3057C157.885 45.5781 157.739 45.2274 162 60.3313Z'
			fill='var(--white1000)'
		/>
	</svg>
);

const elemV = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 311 275'
		fill='none'
	>
		<path
			d='M0.28409 1.68347C0.108967 2.10039 25.9006 63.5012 57.5103 138.338L115.165 274.33L155.258 274.5L195.429 274.747L252.831 139.428C284.441 65.0077 310.31 3.43628 310.486 2.60244C310.739 1.18113 309.289 1.10541 273.739 1.26649L236.642 1.51286L201.695 89.1132C165.542 179.717 158.946 196.991 157.233 206.495C157.011 208.454 156.49 210.371 155.686 212.18C154.328 208.855 153.267 205.421 152.514 201.918C150.569 194.66 138.981 164.462 112.343 97.4612C91.6981 45.5642 74.4779 2.70659 73.9623 2.10016C61.655 0.693078 49.2435 0.357068 36.875 1.09588C16.979 1.09588 0.449484 1.34235 0.28409 1.68347Z'
			fill='var(--white1000)'
		/>
	</svg>
);

const elemG = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 300 292'
		fill='none'
	>
		<path
			d='M138.007 0.418634C136.811 0.589192 132.433 1.16709 128.152 1.66928C102.022 4.54891 77.2242 14.4341 56.5193 30.2246C35.8145 46.015 20.0137 67.0913 10.8775 91.1079C-2.04329 127.812 -2.52406 167.586 9.50581 204.576C16.1039 224.207 27.4101 242.023 42.4875 256.549C61.9313 275.717 87.5488 287.794 115.047 290.755C133.188 292.555 151.487 292.164 169.529 289.59C183.571 286.975 196.944 281.686 208.882 274.026C220.819 266.366 231.085 256.485 239.092 244.951C240.619 242.419 242.367 240.019 244.317 237.778C245.136 244.067 245.62 250.392 245.767 256.729C246.37 267.152 247.051 277.253 247.392 279.252L247.819 282.758H299.043V130.08H148.242V178.471H236.777L236.174 183.209C234.308 195.561 228.122 206.907 218.662 215.331C204.1 228.709 184.961 236.35 164.948 236.774C115.524 240.365 83.6518 218.003 72.8623 172.199C71.0019 157.418 70.828 142.482 72.3457 127.664C77.9983 90.4541 99.3345 66.1782 133.085 58.5884C140.206 57.3474 147.445 56.8706 154.673 57.1669C162.623 56.6352 170.608 57.3681 178.316 59.3368C188.533 61.7133 198.035 66.3942 206.055 73.0023C214.075 79.6103 220.39 87.9608 224.489 97.3808C225.291 99.2948 226.207 101.161 227.233 102.971C227.573 103.388 298.158 90.1226 298.936 89.5351C297.08 81.6435 294.231 74.0054 290.453 66.7941C284.822 55.8594 277.185 46.0199 267.92 37.7614C243.842 16.6135 213.287 3.77036 180.971 1.21442C166.684 0.0201443 152.331 -0.245609 138.007 0.418634Z'
			fill='var(--white1000)'
		/>
	</svg>
);

const elemY = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 302 275'
		fill='none'
	>
		<path
			d='M0.724609 1.51313C0.724609 1.68369 26.9353 42.2575 58.9731 91.6151L117.22 181.385V274.747H184.04V181.641L242.716 91.7857C275.017 42.3144 301.392 1.68369 301.392 1.51313C301.392 1.34257 285.29 1.09615 265.579 1.09615H229.776L194.654 56.6603C159.532 112.471 153.967 121.567 152.936 125.404C152.42 127.243 151.963 126.826 149.044 121.235C146.048 115.474 78.6249 4.43139 76.7472 2.10043C63.9805 0.69649 51.1137 0.36058 38.2882 1.09615C17.5944 1.09615 0.724609 1.26677 0.724609 1.51313Z'
			fill='var(--white1000)'
		/>
	</svg>
);

const elemN = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 274 274'
		fill='none'
	>
		<path
			d='M0.866988 0.684432C0.526471 0.930793 0.263672 62.5022 0.263672 137.51V273.748H61.0798L61.2556 179.723L61.5074 85.6126L65.1962 92.7857C67.9443 98.0093 71.0035 103.071 74.3599 107.946C77.444 112.371 108.413 151.533 143.437 194.883L206.909 273.728L240.065 273.558L273.145 273.312V0.494738L242.984 0.248368L212.747 0.0777588L212.572 93.2689L212.317 186.545L209.401 181.125C202.036 167.272 190.203 151.344 134.485 80.1737C101.591 38.2069 73.8454 3.00567 72.892 1.916L71.1794 0.0777588H36.2607C17.0556 0.0967097 1.11994 0.343316 0.866988 0.684432Z'
			fill='var(--white1000)'
		/>
	</svg>
);

export { elemA, elemV, elemG, elemY, elemN };
